// What POST /api/copywriting/score is sent. A plain module (no React, no path aliases) so
// backend/test/copywriting-route.test.js can import it and prove that what the pages send
// reaches the right scorer.
//
// Only ids and the student's own input go to the server. The exercise itself (brief text,
// options, the original email) is never sent: the server loads it by id from its own copy,
// which is also the only place the grading notes exist.
export const buildScoreBody = ({ exerciseId, moduleId, mode, userText, userChoice, variants, defendedVariant }) => {
  const body = { exerciseId, moduleId, mode, userText };
  if (userChoice !== undefined) body.userChoice = userChoice;
  if (variants !== undefined) body.variants = variants;
  if (defendedVariant !== undefined) body.defendedVariant = defendedVariant;
  return body;
};

export default buildScoreBody;
